import axios from "axios";
import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useEditWarehouseMutation } from "../../features/api/warehouseApi";
import { toast } from "react-toastify";

const EditWarehouse = ({ house }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [wh_name, setWhName] = useState("");
  const [wh_email, setWhEmail] = useState("");
  const [wh_address, setWhAddress] = useState("");
  const [wh_location, setWhLocation] = useState("");
  const [wh_mobile, setWhMobile] = useState("");
  const [wh_web, setWhWeb] = useState("");

  const [updateWarehouse] = useEditWarehouseMutation();
  const handleUpdate = async (id) => {
    try {
      const data = {
        id,
        wh_name: wh_name ? wh_name : house?.wh_name,
        wh_email: wh_email ? wh_email : house?.wh_email,
        wh_address: wh_address ? wh_address : house?.wh_address,
        wh_location: wh_location ? wh_location : house?.wh_location,
        wh_mobile: wh_mobile ? wh_mobile : house?.wh_mobile,
        wh_web: wh_web ? wh_web : house?.wh_web,
      };

      const response = await updateWarehouse(data);
      if (response) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Edit successfull...");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">Wharehouse Update</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 overflow-auto w-full">
                    <input
                      type="text"
                      defaultValue={house?.wh_name}
                      onChange={(e) => setWhName(e.target.value)}
                      className="border pl-1"
                      placeholder="Wharehouse Name"
                    />
                    <input
                      type="email"
                      defaultValue={house?.wh_email}
                      onChange={(e) => setWhEmail(e.target.value)}
                      className="border pl-1"
                      placeholder="Email"
                    />
                    <input
                      type="text"
                      defaultValue={house?.wh_address}
                      onChange={(e) => setWhAddress(e.target.value)}
                      className="border pl-1"
                      placeholder="Address"
                    />
                    <input
                      type="text"
                      defaultValue={house?.wh_location}
                      onChange={(e) => setWhLocation(e.target.value)}
                      className="border pl-1"
                      placeholder="Location"
                    />
                    <input
                      type="text"
                      defaultValue={house?.wh_mobile}
                      onChange={(e) => setWhMobile(e.target.value)}
                      className="border pl-1"
                      placeholder="Mobile"
                    />
                    <input
                      type="text"
                      defaultValue={house?.wh_web}
                      onChange={(e) => setWhWeb(e.target.value)}
                      className="border pl-1"
                      placeholder="Website"
                    />
                  </div>
                  <button
                    onClick={() => handleUpdate(house?.id)}
                    className="bg-green-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditWarehouse;
